import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = ["value", "checked"]
const _hoisted_4 = { slot: "footer" }
const _hoisted_5 = ["disabled"]

import { ref } from 'vue';
import { useStore } from 'vuex';
import { EPINIO_TYPES } from '../../types';
import { epinioExceptionToErrorsArray } from '../../utils/errors';
import Banner from '@components/Banner/Banner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDeleteModal',
  emits: ['deleted'],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore() as any;
const t = store.getters['i18n/t'];

const showModal = ref(false);
const appToDelete = ref<any>(null);
const deleting = ref(false);
const errors = ref<string[]>([]);
const deleteFromRegistry = ref(false);

function openDelete(row: any) {
  appToDelete.value = row;
  errors.value = [];
  showModal.value = true;
}

function closeDelete() {
  showModal.value = false;
  deleteFromRegistry.value = false;
  errors.value = [];
  appToDelete.value = null;
}

async function onSubmitDelete() {
  if (!appToDelete.value) return;

  deleting.value = true;
  errors.value = [];
  const appName = appToDelete.value.meta.name;

  try {
    if (deleteFromRegistry.value) {
      appToDelete.value._deleteImage = true;
    }

    await appToDelete.value.remove();
    emit('deleted', appToDelete.value);
    closeDelete();
    store.dispatch('growl/success', {
      title: 'Application Deleted',
      message: `Your application ${appName} has been successfully deleted.`,
    });
    store.dispatch('epinio/findAll', { type: EPINIO_TYPES.APP, opt: { force: true } });
  } catch (e: any) {
    errors.value = epinioExceptionToErrorsArray(e);
    store.dispatch('growl/error', {
      title: 'Application Deletion Failed',
      message: `Failed to delete application ${appName}. Please try again. Error details: ${e instanceof Error ? e.message : String(e)}`,
    });
  } finally {
    deleting.value = false;
  }
}

__expose({ openDelete });
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[1] || (_cache[1] = _createTextVNode("You are attempting to delete the application ", -1)),
        _createElementVNode("strong", null, _toDisplayString(appToDelete.value?.meta?.name), 1),
        _cache[2] || (_cache[2] = _createTextVNode(".", -1))
      ]),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("trailhand-checkbox", {
        value: deleteFromRegistry.value,
        checked: deleteFromRegistry.value,
        onCheckboxChange: _cache[0] || (_cache[0] = (e) => { deleteFromRegistry.value = e.detail.checked; })
      }, "Also delete image from registry", 40, _hoisted_3),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, "When enabled, the application's container image will be removed from the registry.", -1)),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (err, i) => {
        return (_openBlock(), _createBlock(Banner, {
          key: i,
          color: "error",
          label: err
        }, null, 8, ["label"]))
      }), 128))
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "\n        Cancel\n      ", 32),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        variant: "destructive",
        disabled: deleting.value,
        onButtonClick: onSubmitDelete
      }, _toDisplayString(deleting.value ? 'Deleting...' : _unref(t)('generic.delete')), 41, _hoisted_5)
    ])
  ], 40, _hoisted_1))
}
}

})